import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from '../../locales/en/common.json'
import zhCommon from '../../locales/zh/common.json'
import enAuth from '../../locales/en/auth.json'
import zhAuth from '../../locales/zh/auth.json'

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
  },
  zh: {
    common: zhCommon,
    auth: zhAuth,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  })

export default i18n
